import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { Main, Personal, Privacy } from './components';

function App() {
  return (
    <>
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/personal" element={<Personal />} />
        <Route path="/privacidade" element={<Privacy />} />
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
